import { configureStore } from "@reduxjs/toolkit";
import authReducer from "../pages/Auth/authSlice";
import routeReducer from "./commonSlices/routeSlice";
import adminDashboardReducer from "../pages/AdminDashboard/AdminDashboardSlice";
import notificationsReducer from "./commonSlices/notificationSlice";
import workflowSliceReducer from "./commonSlices/workflowSlice";
import branchReducer from "./commonSlices/branchSlice";
import warehouseReducer from "./commonSlices/warehouseSlice";
import collectionReducer from "./commonSlices/collectionSlice";
import salesReducer from "../pages/Sales/salesSlice";
import salesReturnReducer from "../pages/SalesReturn/salesReturnSlice";
import productsReducer from "../pages/Products/productsSlice";
import customerReducer from "../pages/Customers/customersSlice";
import unitsReducer from "../pages/Units/unitsSlice";
import itemManageReducer from "../pages/Product_manage/itemManageSlice";
import packingReducer from "../pages/Product_manage/PackingStructure/packingSlice";
import productReplaceReducer from "../pages/ProductReplace/productReplaceSlice";
import customerSpecialPriceReducer from "../pages/CustomerSpecialPrice/CustomerSpecialPriceSlice";
import salesRecordReducer from "../pages/SalesRecord/SalesRecordSlice";
import lookupsReducer from "../store/commonSlices/lookupsSlice";
import salesReturnRecordReducer from "../pages/SalesReturnRecord/SalesReturnRecordSlice";
import productReplaceRecordReducer from "../pages/ProductReplaceRecord/ProductReplaceRecordSlice";
import transferReducer from "../pages/Product_transfer/TransferEntrySlice";
import itemAdjustmentReducer from "../pages/AdjustmentEntry/itemAdjustmentSlice";

import quotationReducer from "../pages/Quotation/quotationSlice";
import quotationRecordReducer from "../pages/QuotationRecord/QuotationRecordSlice";
import salesOrderRecordReducer from "../pages/Order/Sales Order/SalesOrderRecord/SalesOrderRecordSlice";
import posReducer from "../pages/POS/posSlice";
import salesOrderReducer from "../pages/Order/Sales Order/Sales Order Entry/salesOrderSlice";
import groupsReducer from "../pages/ItemGroup/groupSlice";
import purchaseOrderReducer from "../pages/Order/Purchase Order/Purchase Order Entry/purchaseOrderSlice";
import purchaseOrderRecordReducer from "../pages/Order/Purchase Order/PurchaseOrderRecord/PurchaseOrderRecordSlice";
import categoriesReducer from "../pages/category/categorySlice";
import itemStockReducer from "../pages/ItemStock/ItemStockSlice";
import itemLedgerReducer from "../pages/ItemLedger/ItemLedgerSlice";
import adjustmentRecordReducer from "../pages/AdjustmentRecord/AdjustmentRecordSlice";
import transferRecordReducer from "../pages/TransferRecord/TransferRecordSlice";
import transferPendingRecordReducer from "../pages/TransferPendingRecord/TransferPendingRecordSlice";
import transferReceiveRecordReducer from "../pages/TransferReceiveRecord/TransferReceiveRecordSlice";
import modelsReducer from "../pages/Models/modelsSlice";
import originsReducer from "../pages/Origins/originsSlice";
import racksReducer from "../pages/Racks/racksSlice";
import serviceEntryReducer from "../pages/Service/Service/Service Entry/serviceSlice";
import serviceRecordReducer from "../pages/Service/Service/ServiceRecord/ServiceRecordSlice";
import serviceExpenseReducer from "../pages/Service/Service Expense/Service Expense Entry/serviceExpenseSlice";
import serviceExpenseRecordReducer from "../pages/Service/Service Expense/ServiceExpenseRecord/ServiceExpenseRecordSlice";
import purchaseEntryReducer from "../pages/Purchase/Purchase/Purchase Entry/purchaseSlice";
import suppliersReducer from "../pages/Purchase/Purchase/Supplier Entry/suppliersSlice";
import purchaseRecordReducer from "../pages/Purchase/Purchase/PurchaseRecord/PurchaseRecordSlice";
import purchaseReturnReducer from "../pages/Purchase/Purchase Return/Purchase Return Entry/purchaseReturnSlice";
import purchaseReturnRecordReducer from "../pages/Purchase/Purchase Return/PurchaseReturnRecord/PurchaseReturnRecordSlice";
import manufacturingReducer from "../pages/Manufacturing/Manufacturing Entry/manufacturingSlice";
import manufacturingRecordReducer from "../pages/Manufacturing/ManufacturingRecord/ManufacturingRecordSlice";
import bomReducer from "../pages/Manufacturing/BOM/bomSlice";
import departmentsReducer from "../pages/Departments/departmentsSlice";
import designationsReducer from "../pages/Designations/designationsSlice";
import crmCustomersReducer from "../pages/CrmCustomers/crmCustomersSlice";
import crmNotificationsReducer from "../pages/Crm/crmNotificationSlice";
import customerPendingReducer from "../pages/customerPendingRecord/CustomerPendingSlice";
import customerApprovedReducer from "../pages/CustomerApprovedRecord/CustomerApprovedSlice";
import customerRejectedReducer from "../pages/customerRejectedRecord/CustomerRejectedSlice";
import crmReportReducer from "../pages/CrmReport/CrmReportSlice";
import leadsReducer from "../pages/Crm/Leads/leadSlice";
import dealsReducer from "../pages/Crm/Deals/dealSlice";
import advanceTransactionReducer from "../pages/AdvanceTransaction/advanceTransactionSlice";
import hrSettingsReducer from "../pages/HrSettings/components/hrSettingsSlice";
import workRoutesReducer from "../pages/WorkRoutes/workRoutesSlice";
import customerDueReducer from "../pages/CustomerDueBalanceReport/CustomerDueSlice";
import customerDueReportReducer from "../pages/Reports/CustomerDueBalanceInvoicewiseReport/customerDueSlice";
import locationsReducer from "../pages/Locations/locationsSlice";
import customerReceiptsReducer from "../pages/CustomerReceipts/customerReceiptSlice";
import supplierPaymentsReducer from "../pages/supplierPayments/supplierPaymentSlice";
import expensesReducer from "../pages/expenses/expenseSlice";
import expenseRecognitionsReducer from "../pages/ExpenseRecognitions/expenseRecognitionsSlice";
import incomesReducer from "../pages/Income/incomeSlice";
import journalsReducer from "../pages/Journal/journalSlice";
import recurringJournalsReducer from "../pages/RecurringJournals/recurringJournalSlice";
import accountsReducer from "../pages/Accounts/accountsSlice";
import contraReducer from "../pages/ContraEntry/contraSlice";
import branchTransactionReducer from "../pages/BranchTransaction/branchTransactionSlice";
import chequesReducer from "../pages/Cheques/chequesSlice";
import salaryPaymentReportReducer from "../pages/salaryPaymentReport/SalaryPaymentReportSlice";
import monthlySalaryReportReducer from "../pages/MonthlySalaryReport/MonthlySalaryReportSlice";
import warehousesReducer from "../pages/Settings/warehouses/warehousesSlice";
import branchManageReducer from "../pages/Settings/Branches/branchSlice";
import institutionReducer from "../pages/Settings/CompanyProfile/institutionSlice";
import attendanceReducer from "../pages/AttendanceEntry/attendanceEntrySlice";
import salesReturnLedgerReducer from "../pages/SalesReturnLedger/SalesReturnLedgerSlice";
import salesLedgerReducer from "../pages/SalesLedger/SalesLedgerSlice";
import advanceCustomerBalanceReducer from "../pages/AdvanceCustomerBalanceReport/AdvanceCustomerBalanceSlice";
import purchaseReturnLedgerReducer from "../pages/PurchaseReturnLedger/PurchaseReturnLedgerSlice";
import purchaseAccountLedgerReducer from "../pages/PurchaseAccountLedger/PurchaseAccountLedgerSlice";
import indirectExpenseLedgerReducer from "../pages/IndirectExpenseLedger/IndirectExpenseLedgerSlice";
import directExpenseLedgerReducer from "../pages/DirectExpenseLedger/DirectExpenseLedgerSlice";
import directExpenseBalanceReducer from "../pages/DirectExpenseBalance/DirectExpenseBalanceSlice";
import expenseRecognitionReducer from "../pages/ExpenseRecognitionRecord/expenseRecognitionSlice";
import customerLedgerReducer from "../pages/Reports/CustomerLedger/customerLedgerSlice";
import collectionReportReducer from "../pages/Reports/SalesCollectionRecord/CollectionReportSlice";
import debtorReceiptRecordReducer from "../pages/Reports/CustomerReceiptRecord/DebtorReceiptRecordSlice";
import emiDueReportReducer from "../pages/Reports/CustomerEmiReport/emiDueSlice";
import supplierDueReducer from "../pages/Reports/SupplierDueBalance/supplierDueSlice";
import supplierOutflowReducer from "../pages/Reports/SupplierWiseOutflow/supplierOutflowSlice";
import outstandingPdcReducer from "../pages/Reports/OutstandingPdc/outstandingPdcSlice";
import supplierLedgerReducer from "../pages/Reports/SupplierLedger/supplierLedgerSlice";
import expenseBalanceReducer from "../pages/Reports/ExpenseBalance/expenseBalanceSlice";
import expenseRecordReducer from "../pages/Reports/ExpenseRecord/expenseRecordSlice";
import advanceCreditorReducer from "../pages/Reports/AdvanceSupplierBalance/AdvanceCreditorSlice";
import creditorPaymentRecordReducer from "../pages/Reports/SupplierPaymentRecord/creditorPaymentRecordSlice";
import salesTaxLedgerReducer from "../pages/Reports/TaxLedger/salesTaxLedgerRecordSlice";
import itemProfitLossReducer from "../pages/Reports/ItemProfitLoss/itemProfitLossSlice";
import billWiseProfitLossReducer from "../pages/Reports/BillWiseProfitLoss/billWiseProfitLossSlice";
import currentAssetLedgerReducer from "../pages/Reports/CurrentAssetLedger/currentAssetLedgerSlice";
import fixedAssetLedgerReducer from "../pages/Reports/FixedAssetLedger/fixedAssetLedgerSlice";
import vatFilingReducer from "../pages/Reports/TaxLedger/vatFilingSlice"
import fixedAssetBalanceReducer from "../pages/Reports/FixedAssetBalance/fixedAssetBalanceSlice";
import intangibleAssetBalanceReducer from "../pages/Reports/IntangibleAsset/intangibleAssetSlice";
import currentAssetBalanceReducer from "../pages/Reports/CurrentAssetBalance/currentAssetBalanceSlice";
import reserveSurplusLedgerReducer from "../pages/Reports/ReserveSurplusLedger/reserveSurplusLedgerSlice";

import salaryPaymentsReducer from "../pages/SalaryPayments/salaryPaymentSlice";
import clientsSuiteReducer from "../pages/Clients/clientsSlice";
import employeesReducer from "../pages/Employees/employeesSlice";
import onboardingReducer from "../pages/Onboarding/onboardingSlice";
import uiDraftsReducer from "./commonSlices/uiDraftsSlice";
import branchLocationReducer from "../pages/BranchLocation/branchLocationSlice";
import accountBalanceReducer from "../pages/AccountBalance/AccountBalanceSlice";
import cashBankAccountLedgerReducer from "../pages/Reports/CashBankAccountLedger/CashBankAccountLedgerSlice";
import dailyLedgerReducer from "../pages/Reports/DailyLedger/DailyLedgerSlice";
import profitLossReducer from "../pages/Reports/ProfitLossReport/ProfitLossSlice";
import loanBalanceReducer from "../pages/Reports/LoanBalance/loanBalanceSlice";
import loanBalanceLedgerReducer from "../pages/Reports/LoanBalanceLedger/LoanBalanceLedgerSlice";
import branchTransferListReducer from "../pages/Reports/BranchTransferList/branchTransferListSlice";
import indirectIncomeBalanceLedgerReducer from "../pages/Reports/IndirectIncomeBalanceLedger/IndirectIncomeBalanceLedgerSlice";
import balanceSheetReducer from "../pages/Reports/BalanceSheet/balanceSheetSlice";
import trialBalanceReducer from "../pages/Reports/TrialBalance/trialBalanceSlice";
import indirectIncomeBalanceReducer from "../pages/Reports/IndirectIncomeBalance/indirectIncomeBalanceSlice";
import directIncomeBalanceReducer from "../pages/Reports/DirectIncomeBalance/directIncomeBalanceSlice";
import branchTransferReceiveReducer from "../pages/Reports/BranchTransferReceiveList/branchTransferReceiveSlice";
import branchTransferPendingReducer from "../pages/Reports/BranchTransferPendingList/branchTransferPendingSlice";
import directIncomeBalanceLedgerReducer from "../pages/Reports/DirectIncomeBalanceLedger/DirectIncomeBalanceLedgerSlice";
import branchLedgerReducer from "../pages/Reports/BranchLedger/BranchLedgerSlice";
import capitalLedgerReducer from "../pages/Reports/CapitalLedger/capitalLedgerSlice";
import branchTransactionOutwardReducer from "../pages/Reports/BranchTransactionOutward/branchTransactionOutwardSlice";
import branchBalanceReducer from "../pages/Reports/BranchBalance/branchBalanceSlice";
import capitalBalanceReducer from "../pages/Reports/CapitalBalance/capitalBalanceSlice";
import incomeRecordReducer from "../pages/Reports/IncomeRecord/incomeRecordSlice";
import contraRecordReducer from "../pages/Reports/ContraRecord/contraRecordSlice";
import serviceExpenseLedgerReducer from "../pages/Reports/ServiceExpenseLedger/ServiceExpenseLedgerSlice";
import serviceAccountLedgerReducer from "../pages/Reports/ServiceAccountLedger/ServiceAccountLedgerSlice";
import investmentAccountLedgerReducer from "../pages/Reports/InvestmentAccountLedger/InvestmentAccountLedgerSlice";
import journalRecordReducer from "../pages/Reports/JournalRecord/journalRecordSlice";
import attendanceOverviewReducer from "../pages/AttendanceOverview/attendanceOverviewSlice";
import patientsReducer from "../pages/PatientsOverview/PatientsSlice";
import doctorsReducer from "../pages/DoctorsOverview/DoctorsSlice";
import salesPharmaReducer from "../pages/SalesPharma/salesSlice";
import insuranceReceiptsReducer from "../pages/InsuranceReciepts/insuranceReceiptSlice";
import gstr3bReducer from "../pages/Reports/GSTR3BSummary/Gstr3BSummarySlice";
import salesReturnGSTR1Reducer from "../pages/Reports/SalesReturnGSTR1/SalesReturnGSTR1Slice";
import purchaseReturnGSTR2Reducer from "../pages/Reports/PurchaseReturnGSTR2/PurchaseReturnGSTR2Slice";
import ageingReducer from "../pages/Reports/AgeingReport/AgeingSlice";
import universalLedgerReducer from "../pages/Reports/AccountTransactionReport/AccountTransactionSlice";
import intangibleAssetLedgerReducer from "../pages/Reports/IntangibleAssetLedger/intangibleAssetLedgerSlice";
import ssccAggregationReducer
from "../pages/Tatmeen/SSCCAggregation/aggregationSlice";
import cuttingLogicReducer from '../pages/Purchase/CuttingLogic/cuttingLogicSlice';
import genericNamesReducer from "../pages/GenericNames/genericNameSlice";
import hierarchyReducer from "../pages/TatmeenHierarchy/hierarchySlice";
import tatmeenPackingReducer from "../pages/Tatmeen/Packing/packingSlice";
import tatmeenShippingReducer from "../pages/Tatmeen/Shipping/shippingSlice";


import deliveryReducer from "../pages/Delivery/deliverySlice";

const store = configureStore({
  reducer: {
    auth: authReducer,
    lookups: lookupsReducer,
    notifications: notificationsReducer,
    adminDashboard: adminDashboardReducer,
    sales: salesReducer,
    salesReturn: salesReturnReducer,
    products: productsReducer,
    customers: customerReducer,
    units: unitsReducer,
    itemManage: itemManageReducer,
    packing: packingReducer,
    route: routeReducer,
    branch: branchReducer,
    warehouse: warehouseReducer,
    collection: collectionReducer,
    productReplace: productReplaceReducer,
    customerSpecialPrice: customerSpecialPriceReducer,
    salesRecord: salesRecordReducer,
    salesReturnRecord: salesReturnRecordReducer,
    productReplaceRecord: productReplaceRecordReducer,
    transferEntry: transferReducer,
    quotation: quotationReducer,
    quotationRecord: quotationRecordReducer,
    salesOrder: salesOrderReducer,
    salesOrderRecord: salesOrderRecordReducer,
    itemAdjustment: itemAdjustmentReducer,
      genericNames: genericNamesReducer,
    groups: groupsReducer,
    pos: posReducer,
    vatFiling: vatFilingReducer,
    purchaseOrder: purchaseOrderReducer,
    purchaseOrderRecord: purchaseOrderRecordReducer,
    categories: categoriesReducer,
    itemStock: itemStockReducer,
    itemLedger: itemLedgerReducer,
    adjustmentRecord: adjustmentRecordReducer,
    transferRecord: transferRecordReducer,
    transferPendingRecord: transferPendingRecordReducer,
    transferReceiveRecord: transferReceiveRecordReducer,
    models: modelsReducer,
    origins: originsReducer,
    racks: racksReducer,
    serviceEntry: serviceEntryReducer,
    serviceRecord: serviceRecordReducer,
    serviceExpense: serviceExpenseReducer,
    serviceExpenseRecord: serviceExpenseRecordReducer,
    purchaseEntry: purchaseEntryReducer,
    purchaseRecord: purchaseRecordReducer,
    suppliers: suppliersReducer,
    purchaseReturn: purchaseReturnReducer,
    purchaseReturnRecord: purchaseReturnRecordReducer,
    manufacturing: manufacturingReducer,
    manufacturingRecord: manufacturingRecordReducer,
    bom: bomReducer,
    departments: departmentsReducer,
    designations: designationsReducer,
    clientsSuite: clientsSuiteReducer,
    employees: employeesReducer,
    onboarding: onboardingReducer,
    uiDrafts: uiDraftsReducer,
    universalLedger: universalLedgerReducer,
    intangibleAssetLedger: intangibleAssetLedgerReducer,
    crmCustomers: crmCustomersReducer,
    crmNotifications: crmNotificationsReducer,
    advanceTransaction: advanceTransactionReducer,
    customerPending: customerPendingReducer,
    customerApproved: customerApprovedReducer,
    customerRejected: customerRejectedReducer,
    crmReport: crmReportReducer,
    hrSettings: hrSettingsReducer,
    ageing: ageingReducer,
    customerDue: customerDueReducer,
    customerDueReport: customerDueReportReducer,
    locations: locationsReducer,
    customerReceipts: customerReceiptsReducer,
    accounts: accountsReducer,
    contra: contraReducer,
    branchTransaction: branchTransactionReducer,
    cheques: chequesReducer,
    salaryPaymentReport: salaryPaymentReportReducer,
    monthlySalaryReport: monthlySalaryReportReducer,
    warehouses: warehousesReducer,
    branchManage: branchManageReducer,
    attendance: attendanceReducer,
    salesReturnLedger: salesReturnLedgerReducer,
    salesLedger: salesLedgerReducer,
    advanceCustomerBalance: advanceCustomerBalanceReducer,
    purchaseReturnLedger: purchaseReturnLedgerReducer,
    purchaseAccountLedger: purchaseAccountLedgerReducer,
    indirectExpenseLedger: indirectExpenseLedgerReducer,
    directExpenseLedger: directExpenseLedgerReducer,
    directExpenseBalance: directExpenseBalanceReducer,
    expenseRecognition: expenseRecognitionReducer,
    customerLedger: customerLedgerReducer,
    collectionReport: collectionReportReducer,
    debtorReceiptRecord: debtorReceiptRecordReducer,
    emiDue: emiDueReportReducer,
    supplierPayments: supplierPaymentsReducer,
    expenses: expensesReducer,
    expenseRecognitions: expenseRecognitionsReducer,
    incomes: incomesReducer,
    journals: journalsReducer,
    recurringJournals: recurringJournalsReducer,
    supplierDue: supplierDueReducer,
    supplierOutflow: supplierOutflowReducer,
    outstandingPdc: outstandingPdcReducer,
    supplierLedger: supplierLedgerReducer,
    expenseBalance: expenseBalanceReducer,
    expenseRecord: expenseRecordReducer,
    creditorPaymentRecord: creditorPaymentRecordReducer,
    advanceCreditor: advanceCreditorReducer,
    salesTaxLedger: salesTaxLedgerReducer,
    reserveSurplusLedger: reserveSurplusLedgerReducer,
    itemProfitLoss: itemProfitLossReducer,
    billWiseProfitLoss: billWiseProfitLossReducer,
    currentAssetLedger: currentAssetLedgerReducer,
    fixedAssetLedger: fixedAssetLedgerReducer,
    fixedAssetBalance: fixedAssetBalanceReducer,
    intangibleAssetBalance: intangibleAssetBalanceReducer,
    currentAssetBalance: currentAssetBalanceReducer,
    salaryPayments: salaryPaymentsReducer,
    branchLocation: branchLocationReducer,
    accountBalance: accountBalanceReducer,
    cashBankAccountLedger: cashBankAccountLedgerReducer,
    dailyLedger: dailyLedgerReducer,
    profitLoss: profitLossReducer,
    loanBalance: loanBalanceReducer,
    loanBalanceLedger: loanBalanceLedgerReducer,
    branchTransferList: branchTransferListReducer,
    indirectIncomeBalanceLedger: indirectIncomeBalanceLedgerReducer,
    balanceSheet: balanceSheetReducer,
    trialBalance: trialBalanceReducer,
    indirectIncomeBalance: indirectIncomeBalanceReducer,
    directIncomeBalance: directIncomeBalanceReducer,
    branchTransferReceive: branchTransferReceiveReducer,
    branchTransferPending: branchTransferPendingReducer,
    directIncomeBalanceLedger: directIncomeBalanceLedgerReducer,
    gstr3b: gstr3bReducer,
    salesReturnGSTR1: salesReturnGSTR1Reducer,
    purchaseReturnGSTR2: purchaseReturnGSTR2Reducer,

    institution: institutionReducer,
    branchLedger: branchLedgerReducer,
    capitalLedger: capitalLedgerReducer,
    branchTransactionOutward: branchTransactionOutwardReducer,
    branchBalance: branchBalanceReducer,
    capitalBalance: capitalBalanceReducer,
    incomeRecord: incomeRecordReducer,
    contraRecord: contraRecordReducer,
    serviceExpenseLedger: serviceExpenseLedgerReducer,
    serviceAccountLedger: serviceAccountLedgerReducer,
    investmentAccountLedger: investmentAccountLedgerReducer,
    journalRecord: journalRecordReducer,
    attendanceOverview: attendanceOverviewReducer,
    patients: patientsReducer,
    doctors: doctorsReducer,
    salesPharma: salesPharmaReducer,
    insuranceReceipts: insuranceReceiptsReducer,
    workflow: workflowSliceReducer,
    leads: leadsReducer,
    deals: dealsReducer,
    workRoutes: workRoutesReducer,
    ssccAggregation: ssccAggregationReducer,
    cuttingLogic: cuttingLogicReducer,
    tatmeenPacking: tatmeenPackingReducer,
    tatmeenShipping: tatmeenShippingReducer,
    hierarchy: hierarchyReducer,
    delivery: deliveryReducer,
  },
});

export default store;
